<template>
  <div class="searchContactForm">
    <div class="searchContactForm__text">
      Skontaktuj się z nami, jeśli chcesz otrzymać informację, gdy produkt będzie dostępny lub
      możliwość zamówienia go u producenta dla Twojej firmy.
    </div>
    <VForm class="searchContactForm__form">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form autocomplete="off" @submit.prevent="handleSubmit(onSubmit)">
          <div class="">
            <ValidationProvider v-slot="{ classes, errors }" rules="required">
              <FormField
                v-model="name"
                name="name"
                type="text"
                label="Imię i nazwisko"
                :class="[classes]"
              >
                <span v-if="errors[0]" class="formField__error">{{ errors[0] }}</span>
              </FormField>
            </ValidationProvider>
            <ValidationProvider v-slot="{ classes, errors }" rules="required|email">
              <FormField
                v-model="email"
                name="email"
                type="email"
                label="Adres e-mail"
                :class="[classes]"
              >
                <span v-if="errors[0]" class="formField__error">{{ errors[0] }}</span>
              </FormField>
            </ValidationProvider>
            <validation-provider v-slot="{ classes, errors }" rules="required|max:12">
              <form-field v-model="taxId" name="nip" type="text" label="NIP" :class="classes">
                <span v-if="errors[0]" class="formField__error">{{ errors[0] }}</span>
              </form-field>
            </validation-provider>
            <client-only>
              <ValidationProvider v-slot="{ classes, errors }" rules="required|phone">
                <FormTel v-model="phone" name="phone" label="Numer telefonu" :class="[classes]" />
                <span v-if="errors[0]" class="formField__error">{{ errors[0] }}</span>
              </ValidationProvider>
            </client-only>

            <ValidationProvider v-slot="{ classes, errors }" rules="required|max:1000">
              <FormTextArea
                v-model="message"
                name="message"
                placeholder="Treść wiadomości"
                :class="classes"
              />
              <span v-if="errors[0]" class="formField__error">{{ errors[0] }}</span>
            </ValidationProvider>
            <div class="searchContactForm__checkbox">
              <ValidationProvider
                v-slot="{ classes, errors }"
                :rules="{ required: { allowFalse: false } }"
              >
                <FormCheckbox
                  id="agreement"
                  name="agreement"
                  v-model="agreement"
                  has-html
                  is-medium
                  :class="classes"
                >
                  Zgadzam się na przetwarzanie moich danych osobowych przez ofix.pl w celu
                  odpowiedzi na moją wiadomość, drogą telefoniczną lub poprzez e‑mail.
                </FormCheckbox>
                <span class="formField__error">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="searchContactForm__button">
            <VButton
              text="Wyślij wiadomość"
              theme="purple"
              type="submit"
              :is-loading="isLoading"
              :disabled="isLoading"
            />
          </div>

          <InfoBar
            v-if="infoBarArray[0].isActive"
            :message="infoBarArray[0].message"
            :icon="infoBarArray[0].config.icon"
            :color="infoBarArray[0].config.color"
            class="vForm__infoBar"
            @close="hideInfoBar(0)"
          />
        </form>
      </ValidationObserver>
    </VForm>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Breadcrumbs from '@/components/Breadcrumbs';
import PageTitle from '@/components/PageTitle';
import VForm from '@/components/VForm';
import FormField from '@/components/Form/FormField';
import FormTel from '@/components/Form/FormTel';
import FormTextArea from '@/components/Form/FormTextArea';
import VButton from '@/components/VButton';
import FormCheckbox from '@/components/Form/FormCheckbox';
import FormCheckboxSimple from '@/components/Form/FormCheckboxSimple';
import InfoBar from '@/components/InfoBar';
import infoBarMixin from '@/mixins/infoBar';
import chatMixin from '~/mixins/chat.js';

export default {
  name: 'SearchContactForm',
  components: {
    InfoBar,
    FormCheckboxSimple,
    FormCheckbox,
    VButton,
    VForm,
    PageTitle,
    Breadcrumbs,
    ValidationProvider,
    ValidationObserver,
    FormField,
    FormTel,
    FormTextArea,
  },
  mixins: [infoBarMixin(), chatMixin],
  props: {
    searchPhrase: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      name: '',
      email: '',
      taxId: '',
      phone: '',
      message: '',
      agreement: false,
      isLoading: false,
    };
  },
  methods: {
    async onSubmit() {
      this.isLoading = true;
      let message = '';
      const formData = new FormData();
      formData.append('firstAndLastName', this.name);
      formData.append('email', this.email);
      formData.append('taxId', this.taxId);
      formData.append('phone', this.phone);
      formData.append('message', this.message);
      formData.append('agreement', this.agreement);
      formData.append('searchPhrase', this.searchPhrase);

      try {
        message = await this.$axios.post(
          `${this.$config.baseOfixApi}/e-commerce/v1/contact`,
          formData,
        );
        this.$refs.form.reset();
        this.name = '';
        this.email = '';
        this.taxId = '';
        this.phone = '';
        this.message = '';
        this.agreement = false;
        this.setInfoBarConfig(0, this.successConfig);
        message = message.data.message;
      } catch (error) {
        if (error.response) {
          message = error.response.data.message
            ? error.response.data.message
            : 'Podczas wysyłania danych z formularza wystąpił błąd.';
        } else {
          message = 'Podczas wysyłania danych z formularza wystąpił błąd.';
        }
        this.setInfoBarConfig(0, this.errorConfig);
      } finally {
        this.isLoading = false;
        this.setInfoBarMessage(0, message);
        this.showInfoBar(0);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.searchContactForm {
  margin-top: 3rem;

  &__text {
    font-size: 1.8rem;
    line-height: 2.6rem;
    color: $cMainDark;
    margin-bottom: 2rem;
  }

  &__form {
    max-width: 60rem;
  }

  &__button {
    margin-top: 20px;
  }

  &__checkbox {
    margin-top: 20px;
  }
}
</style>
